"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const videoStyles_1 = require("../../styling/videoStyles");
const Broadcast_1 = tslib_1.__importDefault(require("./Broadcast"));
const Camera_1 = tslib_1.__importDefault(require("./Camera"));
const CameraOff_1 = tslib_1.__importDefault(require("./CameraOff"));
const Clock_1 = tslib_1.__importDefault(require("./Clock"));
const Close_1 = tslib_1.__importDefault(require("./Close"));
const Collapse_1 = tslib_1.__importDefault(require("./Collapse"));
const Configuration_1 = tslib_1.__importDefault(require("./Configuration"));
const Expand_1 = tslib_1.__importDefault(require("./Expand"));
const Microphone_1 = tslib_1.__importDefault(require("./Microphone"));
const MicrophoneOff_1 = tslib_1.__importDefault(require("./MicrophoneOff"));
const Pause_1 = tslib_1.__importDefault(require("./Pause"));
const Play_1 = tslib_1.__importDefault(require("./Play"));
const ScreenCapture_1 = tslib_1.__importDefault(require("./ScreenCapture"));
const Settings_1 = tslib_1.__importDefault(require("./Settings"));
const Sound_1 = tslib_1.__importDefault(require("./Sound"));
const SoundOff_1 = tslib_1.__importDefault(require("./SoundOff"));
const Fullscreen_1 = tslib_1.__importDefault(require("./Fullscreen"));
const FullscreenExit_1 = tslib_1.__importDefault(require("./FullscreenExit"));
const LaunchOpen_1 = tslib_1.__importDefault(require("./LaunchOpen"));
const styles_1 = tslib_1.__importDefault(require("./styles"));
function Icon({ classes = {}, title, iconName }) {
    const ComponentMap = {
        broadcast: Broadcast_1.default,
        camera: Camera_1.default,
        cameraoff: CameraOff_1.default,
        clock: Clock_1.default,
        close: Close_1.default,
        configuration: Configuration_1.default,
        collapse: Collapse_1.default,
        expand: Expand_1.default,
        fullscreen: Fullscreen_1.default,
        fullscreenexit: FullscreenExit_1.default,
        launchopen: LaunchOpen_1.default,
        microphone: Microphone_1.default,
        microphoneoff: MicrophoneOff_1.default,
        play: Play_1.default,
        pause: Pause_1.default,
        screencapture: ScreenCapture_1.default,
        settings: Settings_1.default,
        sound: Sound_1.default,
        soundoff: SoundOff_1.default,
    };
    const IconType = ComponentMap[iconName];
    const iconClass = iconName.toLowerCase();
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes, target: styles_1.default }, "icons");
    return (react_1.default.createElement("span", { className: `${mergedClasses.root}` },
        react_1.default.createElement(IconType, { title: title, className: `${mergedClasses.icon} ${iconClass}` })));
}
exports.default = Icon;
//# sourceMappingURL=index.js.map